function initializeWkndMediaGallery(modalContent = document) {
  //console.log("[DEBUG] Initializing WKND Media Gallery...");

  // Target elements within the specific modalContent scope (default to document)
  const sliderWrapper = modalContent.querySelector("#wknd-slider-wrapper");
  const slides = modalContent.querySelectorAll(".wknd-slide");
  const nextButton = modalContent.querySelector("#wknd-next");
  const prevButton = modalContent.querySelector("#wknd-prev");
  const pagination = modalContent.querySelector("#wknd-pagination");

  if (!sliderWrapper) {
    console.warn("[DEBUG] Slider wrapper not found in the modal. Initialization aborted.");
    return;
  }

  //console.log("[DEBUG] Number of slides found:", slides.length);

  let currentIndex = 0;
  let startX = 0;
  let isDragging = false;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID;

  // Check if there is more than one slide to initialize
  if (slides.length > 1) {
    //console.log("[DEBUG] Initializing slider controls and pagination.");

    // Clear existing pagination to avoid duplication
    pagination.innerHTML = '';

    // Create pagination dots dynamically
    slides.forEach((_, index) => {
      const dot = document.createElement("span");
      dot.classList.add("wknd-dot");
      if (index === 0) dot.classList.add("active");
      pagination.appendChild(dot);
    });

    const dots = pagination.querySelectorAll(".wknd-dot");

    // Update slide based on index
    function updateSlide(index) {
      //console.log(`[DEBUG] Updating slide to index: ${index}`);
      currentTranslate = index * -100;
      prevTranslate = currentTranslate;
      setSliderPosition();
      dots.forEach((dot) => dot.classList.remove("active"));
      dots[index].classList.add("active");
    }

    // Set the slider position using transform
    function setSliderPosition() {
      //console.log("[DEBUG] Setting slider position to:", currentTranslate);
      sliderWrapper.style.transform = `translateX(${currentTranslate}%)`;
    }

    // Handle animation for dragging
    function animation() {
      setSliderPosition();
      if (isDragging) requestAnimationFrame(animation);
    }

    // Event listeners for navigation buttons
    if (nextButton) {
      nextButton.addEventListener("click", () => {
        //console.log("[DEBUG] Next button clicked");
        currentIndex = (currentIndex + 1) % slides.length;
        updateSlide(currentIndex);
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        //console.log("[DEBUG] Previous button clicked");
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        updateSlide(currentIndex);
      });
    }

    // Event listeners for pagination dots
    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        //console.log(`[DEBUG] Pagination dot clicked: ${index}`);
        currentIndex = index;
        updateSlide(currentIndex);
      });
    });

    // Functions to handle touch events for mobile compatibility
    function touchStart(event) {
      //console.log("[DEBUG] Touch start detected");
      isDragging = true;
      startX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      animationID = requestAnimationFrame(animation);
      sliderWrapper.classList.add('grabbing');
    }

    function touchMove(event) {
      if (isDragging) {
        const currentX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
        const difference = currentX - startX;
        currentTranslate = prevTranslate + (difference / sliderWrapper.clientWidth) * 100;
        //console.log("[DEBUG] Dragging - currentTranslate:", currentTranslate);
      }
    }

    function touchEnd() {
      //console.log("[DEBUG] Touch end detected");
      isDragging = false;
      cancelAnimationFrame(animationID);
      const movedBy = currentTranslate - prevTranslate;

      if (movedBy < -20) {
        //console.log("[DEBUG] Swiped left");
        currentIndex = (currentIndex + 1) % slides.length;
      }

      if (movedBy > 20) {
        //console.log("[DEBUG] Swiped right");
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      }

      updateSlide(currentIndex);
      sliderWrapper.classList.remove('grabbing');
    }

    // Function to add or remove touch events based on screen width
    function toggleTouchEvents() {
      const shouldAddTouchEvents = window.innerWidth <= 1280;
      if (shouldAddTouchEvents) {
        sliderWrapper.addEventListener('touchstart', touchStart, { passive: true });
        sliderWrapper.addEventListener('touchend', touchEnd, { passive: true });
        sliderWrapper.addEventListener('touchmove', touchMove, { passive: true });

        sliderWrapper.addEventListener('mousedown', touchStart);
        sliderWrapper.addEventListener('mouseup', touchEnd);
        sliderWrapper.addEventListener('mousemove', touchMove);
        sliderWrapper.addEventListener('mouseleave', touchEnd);
      } else {
        sliderWrapper.removeEventListener('touchstart', touchStart);
        sliderWrapper.removeEventListener('touchend', touchEnd);
        sliderWrapper.removeEventListener('touchmove', touchMove);

        sliderWrapper.removeEventListener('mousedown', touchStart);
        sliderWrapper.removeEventListener('mouseup', touchEnd);
        sliderWrapper.removeEventListener('mousemove', touchMove);
        sliderWrapper.removeEventListener('mouseleave', touchEnd);
      }
    }

    // Initial check and on resize
    toggleTouchEvents();
    window.addEventListener('resize', toggleTouchEvents);
  } else {
    if (nextButton) nextButton.style.display = 'none';
    if (prevButton) prevButton.style.display = 'none';
    if (pagination) pagination.style.display = 'none';
    ////console.log("[DEBUG] Single slide detected. Hiding navigation controls.");
  }
}

document.addEventListener('DOMContentLoaded', function () {
  ////console.log("[DEBUG] Document loaded. Initializing WKND Media Gallery.");
  initializeWkndMediaGallery();
});

// document.addEventListener("DOMContentLoaded", function () {
//   const sliderWrapper = document.getElementById("wknd-slider-wrapper");
//   const slides = document.querySelectorAll(".wknd-slide");
//   const nextButton = document.getElementById("wknd-next");
//   const prevButton = document.getElementById("wknd-prev");
//   const pagination = document.getElementById("wknd-pagination");

//   let currentIndex = 0;
//   let startX = 0;
//   let isDragging = false;
//   let currentTranslate = 0;
//   let prevTranslate = 0;
//   let animationID;

//   ////console.log("Slider initialized. Total slides:", slides.length);

//   // Only display navigation and pagination if there's more than one slide
//   if (slides.length > 1) {
//     ////console.log("Multiple slides detected, setting up pagination and navigation.");

//     // Create pagination dots dynamically
//     slides.forEach((_, index) => {
//       ////console.log("Creating pagination dot for slide:", index);
//       const dot = document.createElement("span");
//       dot.classList.add("wknd-dot");
//       if (index === 0) dot.classList.add("active");
//       pagination.appendChild(dot);
//     });

//     const dots = document.querySelectorAll(".wknd-dot");

//     // Function to update the slide position
//     function updateSlide(index) {
//       currentTranslate = index * -100;
//       prevTranslate = currentTranslate;
//       setSliderPosition();
//       dots.forEach(dot => dot.classList.remove("active"));
//       dots[index].classList.add("active");
//     }

//     // Set slider position based on currentTranslate
//     function setSliderPosition() {
//       sliderWrapper.style.transform = `translateX(${currentTranslate}%)`;
//     }

//     // Animation function
//     function animation() {
//       setSliderPosition();
//       if (isDragging) requestAnimationFrame(animation);
//     }

//     // Next button event
//     nextButton.addEventListener("click", () => {
//       ////console.log("Next button clicked.");
//       currentIndex = (currentIndex + 1) % slides.length; // Loop back to start when reaching the end
//       updateSlide(currentIndex);
//     });

//     // Previous button event
//     prevButton.addEventListener("click", () => {
//       ////console.log("Previous button clicked.");
//       currentIndex = (currentIndex - 1 + slides.length) % slides.length; // Loop back to end when reaching the beginning
//       updateSlide(currentIndex);
//     });

//     // Pagination dots event
//     dots.forEach((dot, index) => {
//       dot.addEventListener("click", () => {
//         ////console.log("Pagination dot clicked for index:", index);
//         currentIndex = index;
//         updateSlide(currentIndex);
//       });
//     });

//     // Touch Events for Drag Support
//     sliderWrapper.addEventListener('touchstart', touchStart);
//     sliderWrapper.addEventListener('touchend', touchEnd);
//     sliderWrapper.addEventListener('touchmove', touchMove);

//     sliderWrapper.addEventListener('mousedown', touchStart);
//     sliderWrapper.addEventListener('mouseup', touchEnd);
//     sliderWrapper.addEventListener('mousemove', touchMove);
//     sliderWrapper.addEventListener('mouseleave', touchEnd);

//     function touchStart(event) {
//       isDragging = true;
//       startX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
//       animationID = requestAnimationFrame(animation);
//       sliderWrapper.classList.add('grabbing');
//       ////console.log("Touch start detected. StartX:", startX);
//     }

//     function touchMove(event) {
//       if (isDragging) {
//         const currentX = event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
//         const difference = currentX - startX;
//         currentTranslate = prevTranslate + (difference / sliderWrapper.clientWidth) * 100;
//         ////console.log("Touch move detected. Difference:", difference);
//       }
//     }

//     function touchEnd() {
//       isDragging = false;
//       cancelAnimationFrame(animationID);

//       const movedBy = currentTranslate - prevTranslate;

//       // If moved by more than 20% of the width, we consider it a slide change
//       if (movedBy < -20) {
//         ////console.log("Swipe left detected.");
//         currentIndex = (currentIndex + 1) % slides.length; // Loop back to start when reaching the end
//       }

//       if (movedBy > 20) {
//         ////console.log("Swipe right detected.");
//         currentIndex = (currentIndex - 1 + slides.length) % slides.length; // Loop back to end when reaching the beginning
//       }

//       updateSlide(currentIndex);
//       sliderWrapper.classList.remove('grabbing');
//     }
//   } else {
//     // Hide navigation and pagination if there is only one slide
//     ////console.log("Only one slide detected. Hiding navigation and pagination.");
//     nextButton.style.display = 'none';
//     prevButton.style.display = 'none';
//     pagination.style.display = 'none';
//   }

//   // Hide navigation for smaller screens (width < 989px)
//   function updateNavVisibility() {
//     ////console.log("Checking navigation visibility for screen width:", window.innerWidth);
//     if (window.innerWidth <= 989) {
//       ////console.log("Screen width <= 989px. Hiding navigation buttons.");
//       nextButton.style.display = 'none';
//       prevButton.style.display = 'none';
//     } else if (slides.length > 1) {
//       ////console.log("Screen width > 989px. Showing navigation buttons.");
//       nextButton.style.display = 'block';
//       prevButton.style.display = 'block';
//     }
//   }

//   // Initial check and add resize event listener
//   updateNavVisibility();
//   window.addEventListener('resize', updateNavVisibility);
// });
